var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('google-map',{ref:"gm",attrs:{"sharer":_vm.sharerId,"show-lengend":_vm.showLegend,"map-style":"elevation","show-sites":true,"legend":_vm.legend}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }